import React, { Component } from 'react'
import { connect } from "react-redux";
import { Table } from 'reactstrap';
import { Helmet } from 'react-helmet-async';
import IconButton from '@mui/material/IconButton';

import TextField from '@mui/material/TextField';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';
import ConfirmationDialog from "Routes/common/ConfirmationDialog";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

import {
   allRoles,
   addRole,
   editRole,
   statusRole,
   deleteRole
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

class roles extends Component {

   constructor(props) {

      super(props);
      this.confirmationDialog = React.createRef();
      this.state = {
         name: '',
         stdrole: 0,
         adddiv: true,
         editdiv: false,
         eid: '',
         edname: '',
         edstrole: '',
         chkbox: false,
         addchkbox: false,
         rolelist: [],
      };
      this.addHandleSubmit = this.addHandleSubmit.bind(this);
      this.handleaddCheck = this.handleaddCheck.bind(this);
      this.deleteRole = this.deleteRole.bind(this);
      this.editRole = this.editRole.bind(this);
      this.statusRole = this.statusRole.bind(this);
      this.editHandleSubmit = this.editHandleSubmit.bind(this);
      this.handleeditCheck = this.handleeditCheck.bind(this);
      this.onBackSection = this.onBackSection.bind(this);

   }

   UNSAFE_componentWillMount() {
      this.props.allRoles();
   }

   addHandleSubmit(event) {
      event.preventDefault();
      this.props.addRole(this.state.name, this.state.stdrole);
      this.setState({
         name: '',
         stdrole: 0,
         addchkbox: false
      });
   }

   handleaddCheck() {
      var chkrole = this.state.stdrole;
      if (chkrole == 0) {
         this.setState({ stdrole: 1, addchkbox: true });
      } else {
         this.setState({ stdrole: 0, addchkbox: false });
      }

   }

   deleteRole(roleval) {
      this.id = roleval.xrlID;
      this.confirmationDialog.current.openDialog();
   }

   deleteDataPermanent(popupResponse) {

      if (popupResponse) {
         this.props.deleteRole(this.id);
         this.data = ""
      }
   }


   editRole(rawdata) {

      if (rawdata.xrl_stdrole == 1) {
         this.setState({ chkbox: true });
      } else {
         this.setState({ chkbox: false });
      }

      this.setState({
         eid: rawdata.xrlID,
         edname: rawdata.xrl_roleName,
         edstdrole: rawdata.xrl_stdrole,
         adddiv: false,
         editdiv: true
      });
   }

   editHandleSubmit(event) {
      event.preventDefault();
      this.props.editRole(this.state.edname, this.state.edstdrole, this.state.eid);
   }

   handleeditCheck() {
      var chkrole = this.state.edstdrole;
      if (chkrole == 0) {
         this.setState({ edstdrole: 1, chkbox: true });
      } else {
         this.setState({ edstdrole: 0, chkbox: false });
      }

   }

   statusRole(roleid, status) {
      this.props.statusRole(roleid, status);
   }

   onBackSection() {
      this.setState({
         adddiv: true,
         editdiv: false
      });
   }

   render() {
      // const { match, rolelists, loading } = this.props; kk
      const { rolelists, loading } = this.props;
      return (
         <div className="saas-dashboard">
            <Helmet>
               <title>Roles | {AppConfig.appTitle}</title>
               <meta name="description" content="Reactify Sass Dashboard" />
            </Helmet>
            {/* <PageTitleBar title={<IntlMessages id="sidebar.roleheading" />} match={match} /> */} 
            <PageTitleBar title={<IntlMessages id="sidebar.roleheading" />} />
            <div className="row">
               <div className="col-sm-12 col-lg-8">
                  <RctCollapsibleCard heading="List">
                     <div className="table-responsive">
                        <Table hover bordered striped>
                           <thead>
                              <tr className="bg-primary text-white">
                                 <th>Sl.No</th>
                                 <th>Name</th>
                                 <th>Action</th>
                              </tr>
                           </thead>
                           <tbody>
                              {rolelists.map((roleval, idx) => (
                                 <tr key={idx}>
                                    <td>{idx + 1}</td>
                                    <td>{roleval.xrl_roleName}</td>
                                    <td>
                                       {roleval.xrl_status == 1 ? (
                                          <a herf="" onClick={() => this.statusRole(roleval.xrlID, 0)}><span className="badge badge-info" >Active</span></a>
                                       ) : (
                                          <a herf="" onClick={() => this.statusRole(roleval.xrlID, 1)}><span className="badge badge-danger" >Inactive</span></a>
                                       )}
                                       <IconButton className="text-info" aria-label="edit" onClick={() => this.editRole(roleval)}><EditOutlinedIcon  fontSize="medium" /></IconButton>
                                       <IconButton className="text-danger" aria-label="Delete" onClick={() => this.deleteRole(roleval)}><DeleteOutlineOutlinedIcon  fontSize="medium" /></IconButton>
                                    </td>
                                 </tr>
                              ))}

                           </tbody>
                        </Table>
                     </div>
                  </RctCollapsibleCard>
               </div>
               {this.state.adddiv &&
                  <div className="col-sm-6 col-lg-4">
                     <RctCollapsibleCard heading="Add Roles">
                        <form autoComplete="off" onSubmit={(e) => this.addHandleSubmit(e)}>
                           <div className="row">
                              <div className="col-sm-12 col-lg-6 col-xl-12">
                                 <div className="form-group">
                                    <TextField id="name" fullWidth label="Name" required value={this.state.name} onChange={evt => this.setState({ name: evt.target.value })} />
                                 </div>
                                 <div className="form-group">
                                    <input type="checkbox" name="stdrole" checked={this.state.addchkbox} value={this.state.stdrole} onChange={this.handleaddCheck} />{' '}
                                    role is student ?
                                 </div>

                                 <div className="form-group">
                                    <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" />

                                 </div>
                              </div>
                           </div>
                        </form>
                     </RctCollapsibleCard>
                  </div>
               }

               {this.state.editdiv &&
                  <div className="col-sm-6 col-lg-4">
                     <RctCollapsibleCard heading="Edit Roles">
                        <form autoComplete="off" onSubmit={this.editHandleSubmit}>
                           <div className="row">
                              <div className="col-sm-12 col-lg-6 col-xl-12">
                                 <div className="form-group">
                                    <TextField id="name" fullWidth label="Name" required value={this.state.edname} onChange={evt => this.setState({ edname: evt.target.value })} />
                                 </div>
                                 <div className="form-group">
                                    <input type="checkbox" name="stdrole" checked={this.state.chkbox} value={this.state.edstdrole} onChange={this.handleeditCheck} />{' '}
                                    role is student ?
                                 </div>

                                 <div className="form-group">
                                    <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Update" />
                                    <input type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.onBackSection} value="Back" />

                                 </div>
                              </div>
                           </div>
                        </form>
                     </RctCollapsibleCard>
                  </div>
               }
               <ConfirmationDialog
                  ref={this.confirmationDialog}
                  onConfirm={(res) => this.deleteDataPermanent(res)}
                  data={'Role'}
               />
            </div>
         </div>
      )
   }
}




const mapStateToProps = ({ role }) => {
   const { rolelists, loading } = role;
   return { rolelists, loading };
}

export default connect(mapStateToProps, {
   allRoles,
   addRole,
   editRole,
   statusRole,
   deleteRole
})(roles); 